import { createAggrApiInstance } from '@/utils/api/axiosInstance'

import * as aggr from '@/api-generator/aggr/index'

const optionsApi = createAggrApiInstance(aggr.CommonOptionsApi)

export const queryCodes = async (reqData: aggr.PROMCodeTypes) => {
  const res = await optionsApi.optionsQuerycodes(reqData)
  return res
}

export const queryMainTagOptions = async (term?: string, mainTagId?: number) => {
  const res = await optionsApi.optionsQuerymaintag(term, mainTagId)
  return res
}

export const queryCompanyOptions = async (term?: string, companyUuid?: string) => {
  const res = await optionsApi.optionsQuerycompanies(term, companyUuid)
  return res
}

export const queryStaffOptions = async () => {
  const res = await optionsApi.optionsQuerystaffoptions()
  return res
}

export const queryOrganizationOptions = async (companyUuid: string, term?: string) => {
  const res = await optionsApi.optionsQuerycompanyorganizations(companyUuid, term)
  return res
}

export const querySubTagOptions = async (mainTagId: number) => {
  const res = await optionsApi.optionsQuerysubtag(mainTagId)
  return res
}
